import { useI18n } from "../i18n";

export function LangSwitch() {
  const { lang, setLang, t } = useI18n();
  return (
    <button type="button" className="btn secondary small" onClick={() => setLang(lang === "en" ? "ar" : "en")}>
      {t("switchLang")}
    </button>
  );
}
